import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';
import './style.css';
import autosize from 'autosize';
import { Watch } from 'scrollmonitor-react';
import AddAnimationClass from '../../shared/helpers/addAnimationClass';

export default Watch(class Contact extends Component {
    formSent = false;
    isNotARobot = false;
    response = null;

    firstTime = true;
    componentWillUpdate(nextProps) {
        if (typeof nextProps.content !== 'undefined' && this.firstTime) {
            this.props.startWatcher();
            this.firstTime = false;
        }
    }

    componentDidUpdate() {
        if (this._container.classList.contains("loading") && !this.firstTime) {
            this._container.classList.remove("loading");
        }
    }

    componentDidMount() {
        autosize(this._textarea);
        this.props.startWatcher();
    }

    submitForm() {
        if(this.isNotARobot) {
            fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: `form-name=contact&name=${this.name.value}&email=${this.email.value}&phone=${this.phone.value}&message=${this.message.value}&g-recaptcha-response=${this.response}`
            })
                .then((e) => {
                    this.formSent = 'success';
                    this.name.value = '';
                    this.email.value = '';
                    this.phone.value = '';
                    this.message.value = '';
                    this.forceUpdate();
                })
                .catch(error => console.log('form error'));
        }
    }

    render() {
        if (this.props.isInViewport) {
            AddAnimationClass(this._container, 200)
            this.props.stopWatcher();
        }
        return (
            <section id="contact" className="contact site-section" ref={(el) => { this._container = el; }}>
                <span className="decoration-line to-animate"></span>
                <div className="wrapper">
                    <h2 className="section-title to-animate">Contact</h2>
                    <form className="contact-form"
                        onSubmit={e => {
                            e.preventDefault();
                            this.submitForm();
                        }}
                    >
                        <input
                            type="text"
                            id="fields-name"
                            className="contact-form__name to-animate"
                            name="fields[name]"
                            placeholder="Name"
                            ref={e => { this.name = e }}
                        />
                        <input
                            type="email"
                            id="fields-email"
                            className="contact-form__email to-animate"
                            name="fields[email]"
                            required="required"
                            placeholder="Email"
                            ref={e => { this.email = e }}
                        />
                        <input
                            type="text"
                            id="fields-phone"
                            className="contact-form__phone to-animate"
                            name="fields[phone]"
                            placeholder="Number"
                            ref={e => { this.phone = e }}
                        />
                        <textarea
                            className="contact-form__message to-animate"
                            name=""
                            id=""
                            cols="30"
                            rows="30"
                            required="required"
                            ref={(el) => { this._textarea = el }}
                            placeholder="Write your message here..."
                            ref={e => { this.message = e }}
                        >
                        </textarea>
                        <div className="contact-form__captcha">
                            <Recaptcha
                                sitekey="6LcseVQUAAAAAAEStIKxrauDb6O4YpEJnO43_o2C"
                                verifyCallback={(response) => {
                                    this.isNotARobot = true;
                                    this.response = response;
                                    this.forceUpdate();
                                }}
                            />
                        </div>
                        {this.formSent === 'success' ? (
                            <div className='contact-form__success'>Formulaire envoyé</div>
                        ) : (
                                <div className={'contact-form__submit-wrap' + (this.isNotARobot ? ' active' : '')}>
                                    <input className="contact-form__submit to-animate" type="submit" value="Submit" />
                                </div>
                            )}
                    </form>
                </div>
            </section>
        );
    }
});


// WEBPACK FOOTER //
// ./src/components/contact/index.js